import { LucideIcon, LucidePhoneCall, LucidePhoneIncoming, LucideVideo, LucideVideoOff } from '@lucide/angular';
import { CallAttachmentAction } from './call-actions';
import { CallAttachmentState } from './call-state';

export function callAttachmentTitle(state: CallAttachmentState) {
  switch (state) {
    case 'Ready':
      return 'Video call started';
    case 'InProgress':
      return 'Video call in progress';
    case 'Complete':
      return 'Video call ended';
    case 'Disrupted':
      return 'Video call disrupted';
    case 'Missed':
      return 'Video call missed';
  }
}

export function callAttachmentDescription(state: CallAttachmentState, staffName?: string, callDuration?: number) {
  if (!staffName) {
    return '';
  }
  switch (state) {
    case 'Ready':
      return `${staffName} is video calling you`;
    case 'InProgress':
      return `${staffName} is in a video call with you`;
    case 'Complete':
      if (callDuration == null) {
        return `You and ${staffName} were in a call`;
      }
      return `You and ${staffName} were in a call for ${callDuration} min${callDuration === 1 ? '' : 's'}`;
    case 'Disrupted':
      return `Something went wrong with your video call from ${staffName}`;
    case 'Missed':
      return `You missed a video call from ${staffName}`;
  }
}

export function callAttachmentIcon(state: CallAttachmentState): LucideIcon {
  switch (state) {
    case 'Ready':
      return LucidePhoneIncoming;
    case 'InProgress':
      return LucidePhoneCall;
    case 'Complete':
      return LucideVideo;
    case 'Disrupted':
    case 'Missed':
      return LucideVideoOff;
  }
}

export function callAttachmentAction(state: CallAttachmentState, joined: boolean): CallAttachmentAction | null {
  switch (state) {
    case 'Ready':
      return 'join';
    case 'InProgress':
      return joined ? null : 'join';
    default:
      return null;
  }
}
